<template>
  <v-dialog v-model="valueProxy" max-width="300">
    <v-card>
      <v-card-title class="primaryDialogTitle">
        <span>Cancel Rest ?</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Cancel</v-btn>
        <v-btn color="primary" @click="cancel"> Confirm </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { crudDelete } from '@/api/crud';
import api from '@/api';
import { readTimeTables } from '@/api/timetable';

export default {
  name: 'RestCellAction',
  model: {
    prop: 'show',
    event: 'update:show',
  },
  props: {
    id: String,
    show: Boolean,
  },
  data() {
    return {
      model: null,
    };
  },
  computed: {
    valueProxy: {
      get() {
        return this.show;
      },
      set(v) {
        this.$emit('update:show', v);
      },
    },
  },
  watch: {
    valueProxy: {
      immediate: true,
      handler(v) {
        if (v) {
          this.showAction = true;
          this.reload();
        }
      },
    },
  },
  methods: {
    async reload() {
      this.model = await readTimeTables(api, this.id);
    },
    async cancel() {
      await crudDelete(api, 'rml/admin/timetables', this.id);
      this.$emit('cancel', this.model);
      this.close();
    },
    close() {
      this.valueProxy = false;
    },
  },
};
</script>
